import React, {Fragment} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {setDeleteSalaryId, setUpdateSalaryId} from "../../actions/salary";
import CurrencyFormat from "react-currency-format";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Button } from 'react-bootstrap';

const SalaryItem = ({
                        auth,
                        setDeleteSalaryId,
                        setUpdateSalaryId,
                        index,
                        salary: {
                            id, amount, type, employee,
                            date: created_at
                        },
                        showActions,
                        number
                    }) => {

    const {role_name} = auth?.user || {};

    const setDeleteSalary = (id) => {
        setDeleteSalaryId(id);
    };

    const setUpdateSalary = (id) => {
        setUpdateSalaryId(id);
    };

    return (
        <Fragment>
            <tr>
                <th scope="row">{number}</th>
                <td>{employee?.first_name} {employee?.last_name}</td>
                <td>
                    <CurrencyFormat value={amount} displayType={'text'} thousandSeparator={true} suffix={"  so'm"}/>
                </td>
                <td>{type === "fixed" ? "Belgilangan ish haqi" : "Kunlik"}</td>
                <td>
                    <div className="d-flex gap-2">
                        {
                            role_name === 'superadmin' || role_name === 'director' || role_name === 'manager' ? (
                                <Button
                                    variant="outline-primary"
                                    size="sm"
                                    className="d-flex align-items-center justify-content-center"
                                    style={{ width: '32px', height: '32px', padding: 0 }}
                                    onClick={() => setUpdateSalary(id)}
                                >
                                    <FontAwesomeIcon icon={faEdit} />
                                </Button>
                            ) : ''
                        }
                        {
                            role_name === 'superadmin' || role_name === 'director' || role_name === 'manager' ? (
                                <Button
                                    variant="outline-danger"
                                    size="sm"
                                    className="d-flex align-items-center justify-content-center"
                                    style={{ width: '32px', height: '32px', padding: 0 }}
                                    onClick={() => setDeleteSalary(id)}
                                >
                                    <FontAwesomeIcon icon={faTrash} />
                                </Button>
                            ) : ''
                        }
                    </div>
                </td>
            </tr>
        </Fragment>
    );
};

SalaryItem.defaultProps = {
    showActions: true,
};

SalaryItem.propTypes = {
    salary: PropTypes.object.isRequired,
    auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
    auth: state.auth,
});

export default connect(mapStateToProps, {setDeleteSalaryId, setUpdateSalaryId})(
    SalaryItem
);
